(function TripSummaryPagination($, Adzuki)
{
	'use strict';

	const component = {
		props: {
			amount: {
				type    : Number,
				required: true,
			},
			total: {
				type    : Number,
				required: true,
			},
			label: {
				type    : String,
				required: false,
				default : '',
			},
		},
		template: `
			<p v-if="total > 0" class="ts-pagination mb-0 mt-1">
				Displaying <strong>{{ amount }}</strong> of <strong>{{ total }}</strong> {{ label }}
			</p>
		`,
	};

	Adzuki.VueComponents.TripSummaryPagination = component;
}(jQuery, window.Adzuki || {}));
